// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__raUKA","header":"ClearentDisclaimer_header__4Fpgl","inner":"ClearentDisclaimer_inner__Abp8O"};